
<el-button-group class="mr-2">
  <el-button size="mini" class="viewport_btn" label="Desktop" @click="enableDesktopMode">
    <i class="material-icons">desktop_mac</i>
  </el-button>
  <el-button size="mini" class="viewport_btn" label="Mobile" @click="enablePhoneMode">
    <i class="material-icons">phone_iphone</i>
  </el-button>
</el-button-group>
